module.exports = __webpack_public_path__ + "media/packs/images/flags/GY-ec4cc965477ec41850f5394fbbabd148.png";